import { LogIn, LogOut, Ban, PawPrint, Baby } from "lucide-react";
import { useLang } from "@/i18n";
import { FadeUp } from "./Reveal";

const ICONS = [LogIn, LogOut, Ban, PawPrint, Baby];

export default function HouseRules() {
  const { t } = useLang();

  return (
    <section id="regole" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <FadeUp>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-pink-600">{t.rules.eyebrow}</p>
        <h2 className="font-display mt-3 max-w-2xl text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">
          {t.rules.title}
        </h2>
      </FadeUp>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5" data-testid="house-rules-card">
        {t.rules.items.map((rule, i) => {
          const Icon = ICONS[i];
          return (
            <FadeUp key={rule.title} delay={i * 0.08}>
              <div className="group flex h-full flex-col gap-4 rounded-3xl border border-stone-200/80 bg-white p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-pink-300 hover:shadow-xl hover:shadow-pink-600/10">
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-teal-50 text-teal-700 transition-colors duration-300 group-hover:bg-pink-50 group-hover:text-pink-600">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900">{rule.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-stone-500">{rule.desc}</p>
                </div>
              </div>
            </FadeUp>
          );
        })}
      </div>
    </section>
  );
}
